import React, { useMemo } from 'react';

const GLYPH_SET = '01<>[]{}/*+-=~$#@%&';

function generateGlyphRows(seed = 1, rows = 12, rowLength = 56) {
  let state = (seed + 1) * 9301 + 49297;
  const pseudoRandom = () => {
    state = (state * 1103515245 + 12345) % 2147483648;
    return state / 2147483648;
  };

  return Array.from({ length: rows }, (_, idx) => {
    const row = Array.from({ length: rowLength }, () => {
      const glyphIndex = Math.floor(pseudoRandom() * GLYPH_SET.length);
      return GLYPH_SET[glyphIndex];
    }).join('');

    return {
      id: `${seed}-${idx}`,
      row,
      shift: `${Math.round((pseudoRandom() - 0.5) * 32)}px`,
      delay: `${(pseudoRandom() * -8).toFixed(2)}s`,
      duration: `${(9 + pseudoRandom() * 6).toFixed(2)}s`,
      opacity: (0.08 + pseudoRandom() * 0.22).toFixed(2),
    };
  });
}

export default function GlobalCyberBackground() {
  const glyphRows = useMemo(() => generateGlyphRows(7, 13, 54), []);

  return (
    <div className="global-cyber-bg" aria-hidden="true">
      <div className="global-cyber-grid" />
      <div className="global-cyber-glyph-layer">
        {glyphRows.map(({ id, row, shift, delay, duration, opacity }) => (
          <p
            key={id}
            className="global-cyber-glyph-row"
            style={{
              '--glyph-shift': shift,
              '--glyph-delay': delay,
              '--glyph-duration': duration,
              '--glyph-opacity': opacity,
            }}
          >
            {row}
          </p>
        ))}
      </div>
      <div className="global-cyber-readability-veil" />
      <div className="global-cyber-glow global-cyber-glow-top" />
      <div className="global-cyber-glow global-cyber-glow-bottom" />
    </div>
  );
}
